export const CONTACT_EMAIL = 'Contact_Page_Emails'
export const FOLLOW_UP_EMAIL = 'Follow_UP_Modal_Emails'
export const SEND_PROPOSAL_EMAIL = 'Send_Proposal_Emails'
